module.exports = __webpack_public_path__ + "img/cloth_g3_sleeve_15.272065c7.svg";